export default function WhatYouReceiveSection() {
  const benefits = [
    {
      icon: 'ri-check-double-line',
      title: 'Resposta Clara',
      description: 'SIM ou NÃO definitivo. Sem ambiguidades, sem dúvidas. Você saberá a verdade absoluta.',
      color: 'green'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Documentação Profissional',
      description: 'Documentação jurídica, relatório técnico com evidências admissíveis, quando aplicável.',
      color: 'blue'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Orientação e Suporte',
      description: 'Consultoria sobre próximos passos, suporte emocional e orientação jurídica básica.',
      color: 'purple'
    },
    {
      icon: 'ri-key-line',
      title: 'Liberdade para Decidir',
      description: 'Com a verdade em mãos, você terá o poder de tomar a melhor decisão para sua vida.',
      color: 'red'
    }
  ];

  const colorClasses = {
    green: 'bg-green-100 text-green-600 border-green-200',
    blue: 'bg-blue-100 text-blue-600 border-blue-200',
    purple: 'bg-purple-100 text-purple-600 border-purple-200',
    red: 'bg-red-100 text-red-600 border-red-200'
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            O Que Você Recebe
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Muito mais que uma simples investigação. Você recebe <strong>clareza, documentação 
            e suporte</strong> para tomar a melhor decisão.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className={`border-2 ${colorClasses[benefit.color as keyof typeof colorClasses]} rounded-lg p-8 hover:shadow-lg transition-shadow duration-300`}
            >
              <div className="flex items-start space-x-4">
                <div className={`w-16 h-16 ${colorClasses[benefit.color as keyof typeof colorClasses]} rounded-full flex items-center justify-center flex-shrink-0`}>
                  <i className={`${benefit.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <div className="bg-gradient-to-r from-red-50 to-red-100 border border-red-200 rounded-lg p-8">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-red-800 mb-4">
                🎯 Resultado Garantido
              </h3>
              <p className="text-red-700 text-lg mb-6">
                Em <strong>100% dos casos</strong>, entregamos uma resposta definitiva. 
                Você nunca mais ficará na dúvida.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-3xl font-bold text-red-600 mb-2">7-15</div>
                  <div className="text-red-700">Dias para resultado</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-red-600 mb-2">100%</div>
                  <div className="text-red-700">Sigilo garantido</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-red-600 mb-2">24h</div>
                  <div className="text-red-700">Suporte disponível</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
